import { Chip } from "@mui/material";
import React, { useContext, useState } from "react";
import { Col, Row, Spinner, Table } from "react-bootstrap";
import { FiBook } from "react-icons/fi";
import { IoDocument } from "react-icons/io5";
import { useQuery } from "react-query";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  LineChart,
  Line,
  PieChart,
  Pie,
} from "recharts";
import {
  CiBadgeDollar,
  CiCircleMinus,
  CiPercent,
  CiReceipt,
  CiSquareCheck,
} from "react-icons/ci";
import {
  PiCaretDownFill,
  PiCaretUpFill,
  PiCheckCircleFill,
  PiWarningFill,
} from "react-icons/pi";
import { checkExportMandateReportNew, getAllMandates, getMandateReportNewExport, getMyMandates, getTransactions, metricsSmms } from "../services";
import { FaLock, FaLockOpen, FaMoneyBill } from "react-icons/fa";
import { notify } from "../components/actions/CommonActions";
import { grey, red } from "@mui/material/colors";
import { AuthContext } from "../helpers/AuthContext";
import { GoDownload } from "react-icons/go";

export const NewDashboard = () => {
  const [transactions, setTransactions] = useState();
  const [mandates, setMandates] = useState();
  const [statusCounts, setStatusCounts] = useState([]);
  const { user, statuses } = useContext(AuthContext);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [startDate, setStartDate] = useState(formatDate(new Date()));
  const [endDate, setEndDate] = useState(formatDate(new Date()));
        const [isLoading, setIsLoading] = useState(false);
  const [sortedMandatesByNextDebitDate, setSortedMandatesByNextDebitDate] =
    useState();

  const numberFormat = (value, toFixed = 2) => {
    return Number(value)
      .toFixed(toFixed)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
  };


  const {} = useQuery(
    "my-mandates",
    () => {
      if (user?.userData?.role === 999) {
        return getMyMandates(user?.userData?.id);
      } else {
        return getAllMandates();
      }
    },
    {
      onSuccess: (res) => {
        setMandates(res);
        // console.log("this is res", res);
        const approverStatuses = res?.data?.map(
          (entry) => entry.approverStatus
        );
        const statusCountsObj = approverStatuses.reduce((acc, status) => {
          const statusName =
            statuses?.data?.find((s) => s.id === status)?.name || "Unknown";
          acc[statusName] = (acc[statusName] || 0) + 1;
          return acc;
        }, {});

        const statusCountsArray = Object.keys(statusCountsObj).map(
          (statusName) => ({
            approverStatus: statusName,
            count: statusCountsObj[statusName],
          })
        );

        setStatusCounts(statusCountsArray);

        // =========================================================================================================

        const sortedData = [...res?.data].sort((a, b) => {
          const dateA = new Date(a.nextDebitDate);
          const dateB = new Date(b.nextDebitDate);

          return dateA - dateB;
        });

        const top5Data = sortedData.slice(0, 5);

        setSortedMandatesByNextDebitDate(top5Data);

        // console.log(res?.data, top5Data);

        // =========================================================================================================
      },
      onError: (error) => {
        notify("danger", "Error", "Something went wrong");
        console.log(error);
      },
    }
  );


  const { data: metricsData, isLoading: loadingMetrics, isError, error } = useQuery({
  queryKey: ['metricsSmms'],
  queryFn: metricsSmms,
  staleTime: 30 * 60 * 1000, // 30 minutes
  cacheTime: 30 * 60 * 1000, // optional: keep in cache for 30 minutes after unused
});

const handleExportHistory = async (page, limit) => {
  const params = {
    // limit,
    // page,
    from: startDate,
    to: endDate,
    // export: true,
  };

  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) {
      searchParams.append(key, value);
    }
  });

  try {
    await getMandateReportNewExport(searchParams);
  } catch (err) {
    console.log('Export error:', err);
  }
};

// console.log("metrics data: ", metricsData);
 const handleCheckDownload = async () => {
        const params = {
            // status: status,
            from: startDate,
            to: endDate
        }

        const searchParams = new URLSearchParams()
        // Add parameters only if they are defined and not empty
        Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });
                setIsLoading(true)

        await checkExportMandateReportNew(searchParams)
            .then(async (res) => {
                  // console.log("transaction history res ", res);
                  if(res?.canExport == false){
                    notify("danger", "OOPS", `${res?.message}`);
                  }
                  if(res?.count > 0){
                    await handleExportHistory()
                  }
                // setShowSingleDebitModal(false)
                // setFaReport(res?.data)
            })
            .catch((err) => {
                setIsLoading(false)
                notify("danger", "OOPS", `${err?.response?.data?.message}`);
                console.log('err ', err);
            })
                setIsLoading(false)
    }


  return (
    <>
    {loadingMetrics? 
     <div className="d-flex justify-content-center align-items-center vh-100">
      <Spinner animation="border" variant="primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
    :
    <div>
    <p style={{fontWeight: "500", fontSize: 18, marginTop: "10px"}}>Mandate Report:</p>
      <div style={{display: "flex", justifyContent: "space-between", alignItems: "flex-end"}}>
        <div style={{display: "flex"}}>
                        <div>
                            <p style={{fontSize: "14px", marginBottom: "5px"}}>Start date</p>
                            <input type="date" value={startDate} onChange={(e)=> setStartDate(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
                        </div>
                        <div style={{marginLeft: "10px"}}>
                            <p style={{fontSize: "14px", marginBottom: "5px"}}>End date</p>
                            <input type="date" value={endDate} onChange={(e)=> setEndDate(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
                        </div>
                    </div>
                    <div>
                              <button type="button" onClick={handleCheckDownload} style={{ border: "none", backgroundColor: "#007dcc", color: "white", padding: "4px 10px", borderRadius: "5px", marginLeft: "10px" }}><GoDownload color="white" />Export</button>
                              </div>
      </div>
    <div
        className="d-flex align-items-center justify-start gap-2 mt-3"
        style={{ height: "98px" }}
      >
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Total mandates
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.totalMandates}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiBadgeDollar
              style={{ fontSize: "1.5rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Mandates to debit today
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {metricsData?.data?.mandatesToDebitToday}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiSquareCheck
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
      </div>
    <p style={{fontWeight: "500", fontSize: 18, marginTop: "10px"}}>Approval Status:</p>
    <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Approver Status</th>
                      <th>Label</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      metricsData?.data?.approvalStatusMetrics?.map((mandate, index) => (
                        <tr
                          className="hover-detail"
                          key={index}
                        //   onClick={() => {
                        //     navigate(`/all-mandates/${id}/${mandate?.workFlowStatus}`)
                        //   }}
                        >
                          <td className="gray-td">{mandate?.approverStatus}</td>
                          <td className="gray-td">{mandate?.label}</td>
                          <td className="gray-td">{mandate?.count}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>

                <p style={{fontWeight: "500", fontSize: 18, marginTop: "20px"}}>Workflow Status(Approved):</p>
    <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Workflow Status</th>
                      <th>Description</th>
                      <th>Count</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      metricsData?.data?.workflowMetrics?.map((mandate, index) => (
                        <tr
                          className="hover-detail"
                          key={index}
                        //   onClick={() => {
                        //     navigate(`/all-mandates/${id}/${mandate?.workFlowStatus}`)
                        //   }}
                        >
                          <td className="gray-td">{mandate?.workFlowStatus}</td>
                          <td className="gray-td">{mandate?.workFlowStatusDescription}</td>
                          <td className="gray-td">{mandate?.count}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                </div>}
      {/* <div
        className="d-flex align-items-center justify-content-between gap-2 mt-3"
        style={{ height: "98px" }}
      >
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Transactions count
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiBadgeDollar
              style={{ fontSize: "1.5rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Successful transactions
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiSquareCheck
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Failed transactions
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiCircleMinus
              style={{ fontSize: "1.3rem" }}
              className="text-primary"
            />
          </div>
        </div>
        <div
          className="w-25 h-100 rounded p-2 d-flex align-items-center justify-content-between flex-direction-row ml-3"
          style={{ border: "1px solid #d4d4d8" }}
        >
          <div>
            <p className="mb-3 text-muted" style={{ fontSize: "0.9rem" }}>
              Mandates count
            </p>
            <h5 className="mb-0" style={{ color: "#000" }}>
              {numberFormat(124567)}
            </h5>
          </div>

          <div
            className="rounded-circle d-flex align-items-center justify-content-center"
            style={{
              width: "35px",
              height: "35px",
              backgroundColor: "#e6f2fa",
            }}
          >
            <CiReceipt
              style={{ fontSize: "1.6rem" }}
              className="text-primary"
            />
          </div>
        </div>
      </div> */}
    </>

    //   <div id="detail"></div>
  );
};
